<template>
  <div class="accordion" :class="{ 'disabled': disabled }">
    <div class="accordion-header" @click="toggle" :class="{ 'disabled': disabled }">
      <slot :isOpen="isOpen" :close="close" name="header">
        <!-- Default header content if no slot is provided -->
        <span>{{ defaultTitle }}</span>
        <span class="accordion-icon">
          <ZSIcon :color="iconColor" :rotation="isOpen?'180':'0'" :icon="expandIcon"></ZSIcon>
        </span>
      </slot>
    </div>
    <transition name="accordion-content-transition">
      <div v-if="isOpen" class="accordion-content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue';
// import ZSIcon from "@/components/zs-components/global/ZSIcon.vue"

const props = defineProps({
  initiallyOpen: {
    type: Boolean,
    default: false
  },
  defaultTitle: {
    type: String,
    default: 'Accordion Header'
  },
  expandIcon:{
    type:String,
    default:'Chevron'
  },
  iconColor:{
    type:String,
    default:'#333'
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const isOpen = ref(props.initiallyOpen);

const toggle = () => {
  if (props.disabled) return;
  isOpen.value = !isOpen.value;
};

const open = () => {
  isOpen.value = true;
}

const close = () => {
  isOpen.value = false;
}

defineExpose({
  open,
  close,
  toggle
})
</script>

<style>
.accordion {
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
  color:#333;
}

.accordion-header {
  background-color: transparent;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  cursor: pointer;
}

.accordion-header:hover {
  /* background-color: #e9e9e9; */
}

.accordion.disabled .accordion-header {
  cursor: default;
}

.accordion.disabled .accordion-header:hover {
  background-color: transparent;
}

.accordion-icon {
  font-size: 1.2em;
  font-weight: bold;
}

.accordion-content {
  padding: 0;
  /* border-top: 1px solid #ccc; */
  background-color: transparent;
  overflow: hidden; /* Added for smooth transition */
}

.accordion-content-transition-enter-active,
.accordion-content-transition-leave-active {
  transition: max-height 0.2s linear;
  max-height: 500px; /* Adjust as needed, should be larger than the max possible content height */
  opacity: 1;
}
.accordion-content-transition-enter-from,
.accordion-content-transition-leave-to {
  max-height: 0;
}
</style>
